module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.detailList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "factory_qc_name",
      "label": "厂商全称",
      "width": "200"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "factory_short_name",
      "label": "厂商简称"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "admin_name",
      "label": "姓名"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "公司",
      "width": "200"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "position",
      "label": "职位"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "admin_phone",
      "label": "手机号"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "admin_email",
      "label": "邮箱"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "operationtime",
      "label": "报名时间",
      "width": "150"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "operationtime",
      "label": "支付时间",
      "width": "150"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-a20b481a!./~/_vue-loader@9.9.5@vue-loader/lib/template-loader.js?raw&engine=pug!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/sales/detail.vue
// module id = 477
// module chunks = 11